module.exports = __webpack_public_path__ + "img/more.f517a243.png";